var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binding-phone-box"},[_c('div',{staticClass:"content"},[_c('verification',{attrs:{"title":"请绑定手机号","agreementText":"绑定即代表同意","btnName":"立即绑定","smsType":"3"},on:{"callSubmit":_vm.submit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }